export default __webpack_public_path__ + "static/media/container_bg.f86a1fa2.png";